
import { useEffect } from 'react';
// @mui
import { AppBar, Box, Button, Fab, Grid, IconButton, Stack, Toolbar, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// theme
import { bgBlur } from 'src/theme/css';
// hooks
import useOffSetTop from 'src/hooks/useOffSetTop';
import useResponsive from 'src/hooks/useResponsive';
// components
import Searchbar from './Searchbar';

import { useLocation, useNavigate } from 'react-router';
import { useSettingsContext } from 'src/components/settings';
import { useAuthContext } from '../../../auth/hooks';
import Iconify from '../../../components/iconify';
import CartWidget from '../../../pages/standard-components/cart/CartWidget';

import { HEADER, NAV } from '../../config-layout';

import AccountPopover from './AccountPopover';
// import NotificationsPopover from './NotificationsPopover';
import Logo from 'src/components/logo';
import LanguagePopover from "./LanguagePopover";
import SettingsButton from './SettingsButton';

import {
  NotificationsPopover,
} from '../../_common';
import SvgColor from 'src/components/svg-color';


type Props = {
  onOpenNav?: VoidFunction;
  attechLogo?: boolean
};

export default function Header({ onOpenNav, attechLogo }: Props) {

  const { document_title } = useAuthContext();

  const theme = useTheme();

  const settings = useSettingsContext();

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  const lgUp = useResponsive('up', 'lg');

  // const offset = useOffSetTop(HEADER.H_DESKTOP);
  const offset = useOffSetTop();

  const offsetTop = offset && !isNavHorizontal;

  useEffect(() => { }, [document_title])

  const location = useLocation();
  const navigate = useNavigate();

  const renderContent = (
    <>
      {/* {lgUp && isNavHorizontal && <Logo sx={{ mr: 2.5 }} />} */}
      {
        !lgUp && (
          <IconButton onClick={onOpenNav}>
            <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
          </IconButton>
        )
      }
      {!lgUp && (!location.pathname.includes('home')) ?
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ width: '100%', top: 0, display: 'flex', zIndex: 100, left: 0 }}>
          <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box sx={{ '& > :not(style)': { m: 0.5, ml: 1.5 } }}>
              <Fab size='small' aria-label="add" color='inherit' onClick={() => navigate(-1)}>
                <Iconify icon="ic:round-arrow-back" style={{ fontSize: '30px' }} />
              </Fab>
            </Box>
            <Typography variant='subtitle1'>{document_title}</Typography>
            {/* 
              <Box sx={{ '& > :not(style)': { m: 0.5, ml: 1.5 } }}>
                {location.pathname.includes('list') && <Searchbar />}
              </Box> 
            */}
          </Grid>
          <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box sx={{ '& > :not(style)': { m: 0 } }}>
              {/* <CartWidget /> */}
              <AccountPopover />

            </Box>
          </Grid>
        </Stack>
        :
        <>
          {attechLogo && <Logo sx={{ maxWidth: '107px' }} />}
          {/* {location.pathname.includes('list') && <Searchbar />} */}
          {/* <Box sx={{ '& > :not(style)': { m: 0.5, ml: 0 } }}>
            <Button variant="text" onClick={() => navigate(-1)}>
              <Iconify icon="weui:back-filled" style={{ fontSize: '30px', marginRight: 1 }} />
              <Typography variant="caption">
                Back
              </Typography>
            </Button>
          </Box> */}
          <Typography variant='h4'>
            {document_title}
          </Typography>

          <Stack
            flexGrow={1}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            spacing={{ xs: 0.5, sm: 1 }}
          >

            {/* <LanguagePopover />

            <NotificationsPopover /> */}
            {/* 
        {!isDesktop && (!location.pathname.includes('home')) ?
        <><Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ width: '100%', top: 0, position: 'fixed', display: 'flex', zIndex: 100, left: 0 }}>
          <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
            <Box sx={{ '& > :not(style)': { m: 0.5, ml: 1.5 } }}>
              <Fab size='small' aria-label="add" color='inherit' onClick={() => navigate(-1)}>
                <Iconify icon="ic:round-arrow-back" style={{ fontSize: '30px' }} />
              </Fab>
            </Box>
            <Typography variant='subtitle1'>{document_title}</Typography>
            <Box sx={{ '& > :not(style)': { m: 0.5, ml: 1.5 } }}>
              {location.pathname.includes('list') && <Searchbar />}
            </Box>
          </Grid>
          <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
            <Box sx={{ '& > :not(style)': { m: 0 } }}>
              <CartWidget />
            </Box>
          </Grid>
        </Stack></>
        :
        <>
          <Logo />
          {location.pathname.includes('list') && <Searchbar />} */}

            {/* <ContactsPopover /> */}

            {/* <SettingsButton /> */}
            {/* {lgUp && <AccountPopover />} */}
            <AccountPopover />

          </Stack>
        </>
      }
    </>
  );



  return (
    <AppBar
      sx={{
        height: `${HEADER.H_MOBILE}rem`,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          // width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          width: `calc(100% - ${NAV.W_VERTICAL}rem)`,
          height: `${HEADER.H_DESKTOP}rem`,
          ...(offsetTop && {
            // height: HEADER.H_DESKTOP_OFFSET,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: 'background.default',
            // height: HEADER.H_DESKTOP_OFFSET,
            borderBottom: `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI}rem)`,
          }),
        }),
      }}
    >

      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
          minHeight: 'auto !important'
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}


// // @mui
// import { useTheme } from '@mui/material/styles';
// import { Stack, AppBar, Toolbar, Grid, Box, Fab, Typography } from '@mui/material';
// // utils
// import { bgBlur } from '../../../utils/cssStyles';
// // hooks
// import useOffSetTop from '../../../hooks/useOffSetTop';
// import useResponsive from '../../../hooks/useResponsive';
// // config
// import { HEADER } from '../../../config-global';
// // components
// import Logo from '../../../components/logo';
// import Iconify from '../../../components/iconify';
// import { useSettingsContext } from '../../../components/settings';
// //
// import Searchbar from './Searchbar';
// import AccountPopover from './AccountPopover';
// import NotificationsPopover from './NotificationsPopover';
// import { useLocation, useNavigate } from 'react-router';
// import CartWidget from '../../../pages/standard-components/cart/CartWidget';
// import { useEffect } from 'react';
// import { useAuthContext } from '../../../auth/hooks';
// import LanguagePopover from "./LanguagePopover";
// import SettingsButton from './SettingsButton';
// import React from 'react';
// // ----------------------------------------------------------------------

// type Props = {
//   onOpenNav?: VoidFunction;
// };

// export default function Header({ onOpenNav }: Props) {
//   return (<></>);
//   const theme = useTheme();

//   const { document_title } = useAuthContext();

//   const { themeLayout } = useSettingsContext();

//   const navigate = useNavigate();

//   const location = useLocation();

//   const isNavHorizontal = themeLayout === 'horizontal';

//   const isNavMini = themeLayout === 'mini';

//   const isDesktop = useResponsive('up', 'lg');

//   const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP) && !isNavHorizontal;
//   useEffect(() => {
//   }, [document_title])
//   const renderContent = (
//     <>
//       {/* {isDesktop && isNavHorizontal && <Logo sx={{ mr: 2.5 }} />} */}

//       {!isDesktop && (!location.pathname.includes('home')) ?
//         <><Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ width: '100%', top: 0, position: 'fixed', display: 'flex', zIndex: 100, left: 0 }}>
//           <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
//             <Box sx={{ '& > :not(style)': { m: 0.5, ml: 1.5 } }}>
//               <Fab size='small' aria-label="add" color='inherit' onClick={() => navigate(-1)}>
//                 <Iconify icon="ic:round-arrow-back" style={{ fontSize: '30px' }} />
//               </Fab>
//             </Box>
//             <Typography variant='subtitle1'>{document_title}</Typography>
//             <Box sx={{ '& > :not(style)': { m: 0.5, ml: 1.5 } }}>
//               {location.pathname.includes('list') && <Searchbar />}
//             </Box>
//           </Grid>
//           <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
//             <Box sx={{ '& > :not(style)': { m: 0 } }}>
//               <CartWidget />
//             </Box>
//           </Grid>
//         </Stack></>
//         :
//         <>
//           <Logo />
//           {location.pathname.includes('list') && <Searchbar />}


//           <Stack
//             flexGrow={1}
//             direction="row"
//             alignItems="center"
//             justifyContent="flex-end"
//             spacing={{ xs: 0.5, sm: 1.5 }}
//           >
//             <LanguagePopover />
//             <NotificationsPopover />
//             <SettingsButton />


//             {isDesktop && <AccountPopover />}
//           </Stack>
//         </>
//       }
//     </>
//   );

//   return (
//     <AppBar
//       sx={{
//         boxShadow: 'none',
//         height: `${HEADER.H_MOBILE}rem`,
//         justifyContent: 'center',
//         zIndex: theme.zIndex.appBar + 1,
//         color: theme.palette.text.primary,
//         bgcolor: 'background.default',
//         ...bgBlur({
//           color: theme.palette.background.default,
//         }),
//         transition: theme.transitions.create(['height'], {
//           duration: theme.transitions.duration.shorter,
//         }),
//         ...(isDesktop && {
//           width: `100%`,
//           height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
//           borderBottom: `dashed 1px ${theme.palette.divider}`,
//           ...(isOffset && {
//             height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
//           }),
//           ...(isNavHorizontal && {
//             width: 1,
//             bgcolor: 'background.default',
//             height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
//             borderBottom: `dashed 1px ${theme.palette.divider}`,
//           }),
//           ...(isNavMini && {
//             width: `100%`,
//             borderBottom: `dashed 1px ${theme.palette.divider}`,

//           }),
//         }),
//       }}
//     >
//       <Toolbar
//         sx={{
//           height: 1,
//           px: { lg: 5 },
//         }}
//       >
//         {renderContent}
//       </Toolbar>
//     </AppBar>
//   );
// }

